import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd83eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hotspot-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hotspot-header__mask" }, null, -1))
const _hoisted_3 = { class: "hotspot-header__content" }
const _hoisted_4 = { class: "hotspot-header__title-row" }
const _hoisted_5 = { class: "hotspot-header__badge" }
const _hoisted_6 = { class: "hotspot-header__title" }
const _hoisted_7 = {
  key: 0,
  class: "hotspot-header__desc-row"
}

import { ref } from "vue";
import { Image as VanImage } from "vant";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    title: null,
    description: null
  },
  setup(__props: any) {



const isExpanded = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(VanImage), {
            fit: "cover",
            class: "hotspot-header__badge-image",
            src: "https://assets.qiandaocdn.com/admin-upload/f355af433786d9884db8aba781824c48.png",
            alt: "热点"
          })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.title), 1)
      ]),
      (__props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["hotspot-header__desc", { 'hotspot-header__desc--expanded': isExpanded.value }])
            }, _toDisplayString(__props.description), 3),
            _createElementVNode("button", {
              class: "hotspot-header__toggle",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value))
            }, _toDisplayString(isExpanded.value ? "收起" : "展开"), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})